export default "__VITE_ASSET__DcTMASxS__"